
/**
 * @param {Array<String>} labels
 * @param {Number} n
 * @returns {String}
 */
export function plural(labels, n) {
  let idx;
  // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
  if (n % 10 === 1 && n % 100 !== 11) {
      idx = 0; // many
  } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
      idx = 1; // few
  } else {
      idx = 2; // one
  }
  return labels[idx] || '';
}

export const getDiffDays = date => {
	const oneDay = 24 * 60 * 60 * 1000
	const firstDate = new Date()
	const secondDate = new Date(date)

	return Math.round(Math.abs((firstDate - secondDate) / oneDay))
}

export const numDigits = (x) => {
    return Math.max(Math.floor(Math.log10(Math.abs(x))), 0) + 1;
}